import { useMutation, useQueryClient } from 'react-query';

import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';
import { ActionTemplateCreateDTO } from 'config/api/actionLibrary/actionLibrary.types';

type CreateDraftVariables = {
  id: number;
  data: ActionTemplateCreateDTO;
};

const useCreateDraftActionTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(({ id, data }: CreateDraftVariables) => actionTemplatesApi.createDraftActionTemplate(id, data), {
    onSuccess: (_, variables) => {
      // Invalidate queries related to the specific template and the list
      queryClient.invalidateQueries(['actionTemplate', variables.id.toString()]);
      queryClient.invalidateQueries(['actionTemplates']);
    },
  });
};

export default useCreateDraftActionTemplate;
